import React, { useEffect, useState } from "react"
import "./CalendarStyles.css";
import { withTranslation } from "react-i18next"
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter, ModalHeader,
  Row,
  Spinner
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from '@fullcalendar/list';
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import { get, handleApiError, patch, post } from "../../helpers/api_helper"
import Select from "react-select"
import { getUserRoleFromToken } from "../../helpers/auth_token_helper"
import toastr from "toastr"

const CalendarPage = props => {
  const [bags, setBags] = useState([]);
  const [selectedBag, setSelectedBag] = useState(null);

  const [selectedDate, setSelectedDate] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [dayInfo, setDayInfo] = useState([]);
  const [specialDays, setSpecialDays] = useState([]);
  const [dateAgo, setDateAgo] = useState(false);

  const [selectedDayInfo, setSelectedDayInfo] = useState(null);

  const [isSpecialDay, setIsSpecialDay] = useState(false);
  const [specialDayId, setSpecialDayId] = useState(null);
  const [asSpecialDay, setAsSpecialDay] = useState(false);

  const [storeOpen, setStoreOpen] = useState(true);
  const [quantity, setQuantity] = useState(0);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const bagIri = '/v1/api/bags/';
  const role = getUserRoleFromToken();

  const handleDateClick = (arg) => {
    setAsSpecialDay(false);
    const clickedDate = arg.date;
    setSelectedDate(clickedDate);
    setDateAgo(clickedDate < new Date());

    const dayOfWeek = clickedDate.getDay();

    const day = dayInfo.filter((item) => item.day === dayOfWeek)[0];
    const specialDay = specialDays.filter((item) => formatDateLocal(item.specialDate) === formatDateLocal(arg.date))[0];
    if (day) {
      setSelectedDayInfo({
        quantity: day.quantity,
        startCollectionTime: day.startCollectionTime,
        endCollectionTime: day.endCollectionTime,
      });
    } else {
      setSelectedDayInfo({
        quantity: 0,
        startCollectionTime: '',
        endCollectionTime: '',
      });
    }

    if (specialDay) {
      setIsSpecialDay(true);
      setStoreOpen(specialDay.storeOpen);
      setSpecialDayId(specialDay.id);
      setQuantity(specialDay.quantity);
      setStartTime(specialDay.startCollectionTime);
      setEndTime(specialDay.endCollectionTime);
    } else {
      setIsSpecialDay(false);
      setSpecialDayId(null);
      setQuantity(0);
      setStartTime('');
      setEndTime('');
    }

    setShowModal(true);
  };

  const handleSubmitSpecialDay = async () => {
    if ('seller' === role) {
      return false;
    }
    if (!selectedDate || !selectedBag) return;

    const localISODate = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000).toISOString();
    const onlyDate = localISODate.split("T")[0];

    const data = {
      storeOpen,
      quantity,
      startCollectionTime: startTime,
      endCollectionTime: endTime,
    };


      if (!isSpecialDay) {
        const createData = {
          bag: `${bagIri}${selectedBag.value}`,
          specialDate: onlyDate,
          storeOpen: data.storeOpen,
          ...(data.storeOpen && {
            startCollectionTime: data.startCollectionTime,
            endCollectionTime: data.endCollectionTime,
            quantity: data.quantity,
          }),
        };
        try {
          const response = await post('bag-availability-special-days', createData);
          if (201 === response.status) {
            setSpecialDays([...specialDays, response.data]);
            toastr.success('Vos modifications ont été enregistrées avec succès.');
            return;
          }
        } catch (error) {
          console.log(error);
          handleApiError(error.response.data);
        }

      } else {
        try {
          const response = await patch(`bag-availability-special-days/${specialDayId}`, data);
          if (response.status === 200) {
            setSpecialDays(specialDays.map(specialDay =>
              specialDay.id === specialDayId
                ? { ...specialDay, ...response.data }
                : specialDay
            ));
            setShowModal(false);
            toastr.success('Vos modifications ont été enregistrées avec succès.');
          }
        } catch (error) {
          handleApiError(error.response.data);
        }
      }
      setShowModal(false);
  };

  const SpecialDayForm = () => {
    return (
      <Form>
        <Col md={12} className="text-center mb-1">
          <Label className="text-info">Informations du jour spécial</Label>
        </Col>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Le magasin sera ouvert ?</Label>
              <div
                className="form-check form-switch form-switch-md mb-3"
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="customSwitchsizemd"
                  value={storeOpen}
                  checked={storeOpen}
                  onChange={() => {setStoreOpen(!storeOpen)}}
                />
                {storeOpen ? '(Oui)' : '(Non)'}
              </div>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Quantité disponible</Label>
              <Input
                type="number"
                min={0}
                value={quantity}
                onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
                disabled={!storeOpen}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Heure de début</Label>
              <Input
                type="time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                disabled={!storeOpen}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Heure de fin</Label>
              <Input
                type="time"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                disabled={!storeOpen}
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    );
  };

  const formatDateLocal = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) {
      throw new Error("Date invalide : " + dateString);
    }
    const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

    return adjustedDate.toISOString().split("T")[0];
  }

  const renderDayCell = (arg) => {
    const dayOfWeek = arg.date.getDay();

    const day = dayInfo.filter((item) => item.day === dayOfWeek)[0];
    const specialDay = specialDays.filter((item) => formatDateLocal(item.specialDate) === formatDateLocal(arg.date))[0];

    let color = specialDay ? '#50a5f1' : (day ? day.color : "#f46a6a");

    return (
      <div className='fc-daygrid-cell-content'>
        <div className='day-number'>{arg.dayNumberText}</div>
        <div className={`day-circle ${arg.dayNumberText.length === 1 ? 'ml-2' : 'ml-4'}`} style={{ backgroundColor: color }} />
      </div>
    );
  };

  const getAvailabilityStatus = (bagAvailabilities) => {
    let statusMap = [];

    bagAvailabilities.forEach((availability) => {
      const normalizedDay = availability.dayOfWeek === 7 ? 0 : availability.dayOfWeek;

      if (!statusMap[normalizedDay]) {
        statusMap[normalizedDay] = [];
      }

      statusMap[normalizedDay]['day'] = normalizedDay;
      statusMap[normalizedDay]['quantity'] = availability.quantity;
      statusMap[normalizedDay]['startCollectionTime'] = availability.startCollectionTime;
      statusMap[normalizedDay]['endCollectionTime'] = availability.endCollectionTime;
      statusMap[normalizedDay]['color'] = availability.quantity > 0 ? "#007B7F" : "#ff0000c9";
    });

    return statusMap;
  };

  const handleSelectBag = (value) => {
    const selected = bags.find(bag => bag.value === value);
    setSelectedBag(selected || null);
  };

  const fetchBags = async () => {
    const responseBags = await get('bags');
    if (200 === responseBags.status && responseBags.data['hydra:member'].length > 0) {
      const newBags = responseBags.data['hydra:member'].map(item => ({
        label: item.name,
        value: item.id
      }));
      setBags(newBags);
      //setSelectedBag(newBags[0]);
    }
  }

  const fetchAvailabilities = async () => {
    if (!selectedBag) {
      return;
    }

    const responseAvailabilities = await get('bag-availabilities', {'bag': selectedBag.value});
    if (200 === responseAvailabilities.status) {
      setDayInfo(getAvailabilityStatus(responseAvailabilities.data['hydra:member']));
    }
  }

  const fetchSpecialDays = async () => {
    if (!selectedBag) {
      return;
    }

    try {
      const responseSpecialDays = await get("bag-availability-special-days", {
        bag: selectedBag?.value,
      });
      if (200 === responseSpecialDays?.status) {
        setSpecialDays(responseSpecialDays.data['hydra:member']);
      }
    } catch (e) {
      console.error("Erreur chargement jour spécial", e);
    }
  }

  useEffect(() => {
    fetchBags();
  }, [])

  useEffect(() => {
    fetchAvailabilities();
    fetchSpecialDays();
  }, [selectedBag]);

  if ((!bags && bags.length === 0)) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Calendrier")}
                       breadcrumbItem={props.t("Calendrier")} />
          <div className="my-2">
            <div className="mb-3">
              <div className="p-4 shadow-sm border-0">
                <p className="mt-2">
                  Le calendrier vous offre un aperçu des jours où vos clients peuvent venir récupérer un <strong>panier</strong> dans votre magasin.
                </p>
                <hr />
                <p>
                  Vous avez la possibilité de <strong>marquer certains jours comme jours spéciaux</strong>, par exemple pour signaler :
                </p>
                <ul className="mb-3">
                  <li className="d-flex align-items-center"><i className="bx bx-block font-size-18" /> <strong className="mx-2">Une fermeture exceptionnelle</strong></li>
                  <li className="d-flex align-items-center"><i className="bx bx-poll font-size-18" /> <strong className="mx-2">Un ajustement temporaire de la quantité disponible</strong></li>
                  <li className="d-flex align-items-center"><i className="bx bx-time font-size-18" /> <strong className="mx-2">Un ajustement temporaire des heures de collecte</strong></li>
                </ul>
                <p>
                  Ces jours spéciaux vous permettent d’<strong>adapter votre disponibilité</strong> en fonction des circonstances et d'informer vos clients en toute transparence.
                </p>
                <p className="fw-bold">
                  Le planning affiché dans le calendrier est basé sur les disponibilités configurés dans le "Planificateur des collectes"
                </p>
                <p className="fw-bold">
                  <span className="px-2 py-1 ms-0 mx-2 rounded-circle bg-success"></span> <span>Collection disponible</span>
                  <span className="px-2 py-1 mx-2 rounded-circle bg-danger"></span> <span>Pas de Collection disponible</span>
                  <span className="px-2 py-1 mx-2 rounded-circle bg-info"></span> <span>Jour spécial</span>
                </p>
              </div>
            </div>

            <div className="d-flex justify-content-end align-items-center mb-5">
              <span className="text-info mx-3 fw-bold">Sélectionner un Panier</span>
              <select
                value={selectedBag?.value || ''}
                onChange={e => handleSelectBag(e.target.value)}
                className="form-select w-75"
              >
                <option value="">-- Choisir un panier --</option>
                {bags.map(bag => (
                  <option key={bag.value} value={bag.value}>
                    {bag.label}
                  </option>
                ))}
              </select>
            </div>

            <Row>
              <Col md={12}>

                {
                  selectedBag ?
                    <FullCalendar
                      plugins={[
                        BootstrapTheme,
                        dayGridPlugin,
                        listPlugin,
                        interactionPlugin,
                      ]}
                      slotDuration={"00:15:00"}
                      handleWindowResize={true}
                      themeSystem="bootstrap"
                      headerToolbar={{
                        start: '',
                        center: 'prev title next',
                        end: 'today'
                      }}
                      locale={'fr'}
                      firstDay={1}
                      editable={true}
                      selectable={true}
                      dateClick={handleDateClick}
                      dayCellContent={renderDayCell}
                      buttonText={{
                        today: 'Aujourd\'hui',
                      }}
                    />
                    :
                    <p className="fw-bold justify-content-center text-center mt-3">
                      Sélectionner un panier depuis la liste déroulante pour afficher le calendrier des disponibilités
                    </p>
                }
              </Col>
            </Row>

            {selectedDate && (
              <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered>
                <ModalHeader toggle={() => setShowModal(false)}>
                  <span className="text-capitalize">{selectedDate.toLocaleDateString("fr-FR", {
                    weekday: "long", day: "2-digit", month: "long"
                  })}</span>
                </ModalHeader>
                <ModalBody>
                  {selectedDayInfo?.quantity > 0 ? (
                    <p className='fw-bold text-success'>
                      Collection disponible
                      {
                        isSpecialDay && (
                          <span className="text-info fw-bold"> (Jour spécial)</span>
                        )
                      }
                    </p>
                  ) : (
                    <p className='fw-bold text-danger'>
                      Pas de Collection disponible
                      {
                        isSpecialDay && (
                          <span className="text-info fw-bold"> (Jour spécial)</span>
                        )
                      }
                    </p>
                  )}

                  <hr />
                  <p className={`fw-bold mb-1 ${!selectedDayInfo?.quantity ? 'text-muted' : '' }`}>
                    Quantité de Paniers : {selectedDayInfo?.quantity ?? '-' }
                  </p>
                  <p className={`fw-bold ${!selectedDayInfo?.quantity ? 'text-muted' : '' }`}>
                    Heure de collecte : {selectedDayInfo?.startCollectionTime} - {selectedDayInfo?.endCollectionTime}
                  </p>
                  <hr />
                  {
                    (!isSpecialDay && !asSpecialDay && !dateAgo) &&
                    ('admin' === role || 'manager' === role) && (
                      <Button color="success" className="btn w-100" onClick={() => setAsSpecialDay(true)}>
                        Définir comme jour spécial
                      </Button>
                    )
                  }
                  {
                    (isSpecialDay || asSpecialDay) &&
                    (
                      <>
                        {SpecialDayForm()}
                        {
                          !dateAgo && (
                            <Button color="success" className="w-100" onClick={handleSubmitSpecialDay}>
                              { isSpecialDay ? "Mettre à jour" : "Créer" } le jour spécial
                            </Button>
                          )
                        }
                      </>
                    )
                  }
                </ModalBody>
              </Modal>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>

  );
};

export default withTranslation()(CalendarPage);
